import React from "react";
import * as Styles from "./styles/FilterBackButtonStyles";
import {
    IconArrowLeftLong,
    IconArrowRightLong,
} from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";

type FilterBackButtonType = {
    onClick: () => void;
    text: string;
    arrowDirection: "left" | "right";
    fullWidth?: boolean;
};

const FilterArrowButton = ({ onClick, text, arrowDirection, fullWidth }: FilterBackButtonType): JSX.Element => {
    return (
        <Styles.Button onClick={onClick} direction={arrowDirection} fullWidth={fullWidth}>
            {arrowDirection === "left" && (
                <Styles.IconLeftWrapper>
                    <IconArrowLeftLong />
                </Styles.IconLeftWrapper>
            )}
            {text}
            {arrowDirection === "right" && (
                <Styles.IconRightWrapper>
                    <IconArrowRightLong />
                </Styles.IconRightWrapper>
            )}
        </Styles.Button>
    );
};

export default FilterArrowButton;
